export default class CustomerInfo {
  public found = false
  public licenseplate = ''
  public mobilePhone = ''
  public name = ''
  public email = ''
  public comment = ''
}
